import { Store } from "../../../@core/store/store";

export class BingSearchLoadingState extends Store.AbstractLoadingState<any> {}
export class BingSearchLoadingErrorState extends Store.AbstractErrorState<any> {}
export class BingSearchLoadedState extends Store.AbstractIdealState<any> {}

export class ApplicationSearchLoadingState extends Store.AbstractLoadingState<any> {}
export class ApplicationSearchLoadingErrorState extends Store.AbstractErrorState<any> {}
export class ApplicationSearchLoadedState extends Store.AbstractIdealState<any> {}

export class profileDataLoadingState extends Store.AbstractLoadingState<any> { }
export class profileDataLoadingErrorState extends Store.AbstractErrorState<any> { }
export class profileDataLoadedState extends Store.AbstractIdealState<any> { }
